<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="actiontask_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$select",
					"field": "taskindex",
					"title": "选择任务",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '选择执行任务',
				modal_width:500,
				modal_height:300,
				taskList:[]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			
			modal_init(){
				this.$api.campaign.listtask().then((res) => {
					let taskList = res.list
					this.sourceData = this.data
					let formData = JSON.parse(JSON.stringify(formjson))
					// console.log(this.data)
					let options = this.data.config.map((item)=>{
						let task = item.task.map((titem)=>{
							let target = taskList.find((_titem)=>{
								return titem == _titem.id
							})
							if(target){
								return target.name
							}
							return '未知'
						})
						// console.log(item.time)
						return {
							label:this.$Moment(parseInt(item.time)).format('HH:mm') + '【'+task.join('|')+'】',
							value:item.md5,
						}
					})
					
					let rule = formData.rule.rule
					rule.forEach((item)=>{
						if(item.field == 'taskindex'){
							item.options = options
						}
					})
					let option = formData.rule.option
					option.el = this.$refs.actiontask_form
					this.fApi = this.$formCreate(rule, option)
					this.fApi.nextTick(() => {
						this.regestevent(rule)
						this.setFormData()		
					})
					this.$emit('show')
				})

			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},

			submit() {
				this.fApi.submit((formData) => {
					// console.log(formData)
					formData.planid = this.data.id
					this.$emit('success',formData)
					this.$nextTick(() => {
						this.modal_cancel()
					})
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>